import styled from 'styled-components';

import { TabContent } from './TabContent';

import type { RenderTab } from './types';

export const StyledButton = styled.button({
  height: '100%',
});

export const defaultRenderTab: RenderTab = ({
  className,
  isCurrent,
  label,
  onClick,
  tab,
}) => (
  <StyledButton
    type="button"
    className={className}
    onClick={onClick}
  >
    <TabContent
      isCurrent={isCurrent}
      label={label}
      tab={tab}
    />
  </StyledButton>
);
